import React, { useEffect } from "react";
import Select from "react-select";

import { Drawer, DrawerBody, DrawerHeader, DrawerOverlay, DrawerContent } from "@chakra-ui/react";
import { DrawerCloseButton, Input, Button } from "@chakra-ui/react";
import { isEmpty, unset } from "lodash";

import DateRangePicker from "@/components/Common/DateRangePicker";

const UserFilter = (props) => {
  const { isOpen, onClose, countryOptions, setFilters, setDateRange, dateRange } = props;
  const { inputData, setInputData, setFormValues, formValues, filters, handleOnReset, orgId } = props;

  useEffect(() => {
    setFormValues(filters);
  }, [filters]);

  useEffect(() => {
    setFormValues(filters);
  }, []);

  const handleOnChanges = (key, value) => {
    setInputData({
      ...inputData,
      [key]: value,
    });
    let newValue;
    if (Array.isArray(value)) newValue = value.map((data) => data.value);
    else newValue = value.trim();
    setFormValues({
      ...formValues,
      [key]: newValue,
    });
  };

  const onChangeDateRange = (start, end) => {
    setDateRange({ startDate: start, endDate: end });
    setFormValues({
      ...formValues,
      ["dateRange"]: { startDate: start, endDate: end },
    });
  };

  const handleOnClear = () => {
    onClose();
    handleOnReset();
  };

  const handleOnFilter = () => {
    Object.keys(formValues).map((key) => {
      if (isEmpty(formValues[key])) unset(formValues, key);
    });
    setFilters(formValues);
    onClose();
  };

  const statusOptions = [
    // { label: "Trial User", value: "trial_user" },
    { label: "KYC Initiated", value: "kyc_initiated" },

    { label: "KYC Success", value: "kyc_success" },
    // { label: "Approved", value: "approved" },
    { label: "User Approved", value: "user_approved" },
    // { label: "Active", value: "active" },

    { label: "Pending", value: "pending" },
    { label: "Address Pending", value: "address_pending" },
    // { label: "Sof Pending", value: "sof_pending" },
    { label: "KYC Pending", value: "kyc_pending" },
    { label: "KYC Manual Review", value: "kyc_manual_review" },
    { label: "KYC PEP Review", value: "kyc_pep_review" },

    { label: "KYC Blocked", value: "kyc_blocked" },
    { label: "KYC Expired", value: "kyc_expired" },
    { label: "KYC Rejected", value: "kyc_rejected" },
    { label: "KYC Failed", value: "kyc_failed" },
    { label: "User Rejected", value: "user_rejected" },
    // { label: "Rejected", value: "rejected" },
    // { label: "Blocked", value: "blocked" },
    // { label: "Inactive", value: "inactive" }, //for pay solution only
  ];

  return (
    <>
      <Drawer onClose={onClose} isOpen={isOpen} size={"sm"}>
        <DrawerOverlay />
        <DrawerContent>
          <DrawerCloseButton />
          <DrawerHeader style={{ color: "#3182ce", fontFamily: "arial" }}>Filters</DrawerHeader>
          <DrawerBody>
            <div style={{ margin: "12px 0" }}>
              <DateRangePicker width={"100%"} onChangeDateRange={onChangeDateRange} start={dateRange.startDate} end={dateRange.endDate} />
            </div>
            <div style={{ margin: "12px 0" }}>
              <Input
                placeholder={"User Id"}
                style={{ border: "1px solid hsl(0, 0%, 80%)" }}
                type="text"
                value={formValues.userId}
                onChange={(e) => handleOnChanges("userId", e.target.value)}
              />
            </div>
            <div style={{ margin: "12px 0" }}>
              <Input
                placeholder={"Email"}
                style={{ border: "1px solid hsl(0, 0%, 80%)" }}
                type="text"
                value={formValues.email}
                onChange={(e) => handleOnChanges("email", e.target.value)}
              />
            </div>
            {orgId === "OG-220923101501950" && (
              <div style={{ margin: "12px 0" }}>
                <Input
                  placeholder={"Owner"}
                  style={{ border: "1px solid hsl(0, 0%, 80%)" }}
                  type="text"
                  value={formValues.owner}
                  onChange={(e) => handleOnChanges("owner", e.target.value)}
                />
              </div>
            )}
            <div style={{ margin: "12px 0" }}>
              <Select
                isMulti
                isSearchable={false}
                placeholder={"Status"}
                options={statusOptions}
                value={inputData.status}
                onChange={(e) => handleOnChanges("status", e)}
              />
            </div>
            <div style={{ margin: "12px 0" }}>
              <Select
                isMulti
                isSearchable={false}
                placeholder={"Country"}
                options={countryOptions}
                value={inputData.country}
                onChange={(e) => handleOnChanges("country", e)}
              />
            </div>

            <div style={{ marginTop: "30px" }}>
              <Button onClick={() => handleOnFilter()} variant={"outline"} colorScheme="blue">
                {"Filter"}
              </Button>
              <Button onClick={() => handleOnClear()} variant={"outline"} colorScheme="red" style={{ marginLeft: "30px" }}>
                {"Clear"}
              </Button>
            </div>
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </>
  );
};

export default UserFilter;
